import React from 'react';
import ReactDOM from 'react-dom';
import Home from './pages/Home';
import './App.css'; // Wichtig: CSS hier importieren, falls noch nicht geschehen

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
);